/* Latteo: arreglo de los botones + / - / eliminar del carrito lateral */
(function () {
  if (window.__latteoCartFix) return;
  window.__latteoCartFix = true;
  var busy = false;

  function cartDrawer() { return document.querySelector('cart-drawer'); }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function refresh(cart) {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return Promise.all([
      fetch(cartUrl + '?section_id=cart-drawer').then(function (r) { return r.text(); }),
      fetch('/?section_id=cart-icon-bubble').then(function (r) { return r.text(); })
    ]).then(function (res) {
      var newInner = parse(res[0]).querySelector('.drawer__inner');
      var curInner = document.querySelector('cart-drawer .drawer__inner');
      if (newInner && curInner) curInner.innerHTML = newInner.innerHTML;
      var newBubble = parse(res[1]).querySelector('.shopify-section');
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && newBubble) bubble.innerHTML = newBubble.innerHTML;
      var d = cartDrawer();
      if (d) d.classList.toggle('is-empty', cart.item_count === 0);
    });
  }

  function changeLine(line, quantity) {
    if (busy || !line) return;
    busy = true;
    var inner = document.querySelector('cart-drawer .drawer__inner');
    if (inner) inner.style.opacity = '0.6';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.status && cart.description) { throw new Error(cart.description); }
        return refresh(cart);
      })
      .catch(function (e) { console.error('Latteo cart', e); })
      .then(function () {
        busy = false;
        var i = document.querySelector('cart-drawer .drawer__inner');
        if (i) i.style.opacity = '';
      });
  }

  function stop(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('cart-drawer')) return;
    var qtyBtn = e.target.closest('.quantity__button');
    var removeBtn = e.target.closest('.cart-remove-button');
    if (!qtyBtn && !removeBtn) return;
    stop(e);
    if (removeBtn) {
      var holder = removeBtn.closest('cart-remove-button');
      changeLine(parseInt(holder && holder.dataset.index, 10), 0);
      return;
    }
    var wrap = qtyBtn.closest('quantity-input');
    var input = wrap && wrap.querySelector('input.quantity__input');
    if (!input) return;
    var qty = (parseInt(input.value, 10) || 0) + (qtyBtn.getAttribute('name') === 'plus' ? 1 : -1);
    if (qty < 0) qty = 0;
    var max = parseInt(input.getAttribute('max'), 10);
    if (max && qty > max) return;
    changeLine(parseInt(input.dataset.index, 10), qty);
  }, true);

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('cart-drawer')) return;
    var input = e.target.closest('input.quantity__input');
    if (!input) return;
    stop(e);
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    changeLine(parseInt(input.dataset.index, 10), qty);
  }, true);
})();
